import { IconNames } from '@petsmart-ui/sparky';
import { create } from 'zustand';
import { SearchStore } from '@libs/common-types';
export type StoreDrawerOptions = {
  className?: string;
  toggleText?: string;
  drawerHeading?: string;
  alertIcon?: IconNames;
  alertHeading?: string;
  sku?: string;
  minPurchaseQuantity?: number;
  filterFn?: (stores: SearchStore[]) => SearchStore[];
};
export type StoreDrawerState = {
  isOpen: boolean;
  options: StoreDrawerOptions;
  open: (options?: StoreDrawerOptions) => Promise<string | null>;
  close: (result: string | null) => void;
  _resolver?: (result: string | null) => void;
};
export const useStoreDrawerStore = create<StoreDrawerState>((set, get) => ({
  isOpen: false,
  options: {},
  open: (options = {}) => {
    return new Promise(resolve => {
      set({
        isOpen: true,
        options,
        _resolver: resolve
      });
    });
  },
  close: (result: string | null) => {
    const resolver = get()._resolver;
    if (resolver) {
      resolver(result);
    }
    set({
      isOpen: false,
      _resolver: undefined
    });
  }
}));
export function useStoreDrawer() {
  return useStoreDrawerStore(_temp);
}
function _temp(state) {
  return state.open;
}